export const CATEGORY_OF_PRODUCT_API_END_POINT = process.env.RAZZLE_CATEGORY_OF_PRODUCT_API_END_POINT || 'category-of-products'
export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
